import { priceTooltipToggleTpl } from '../priceToggle/priceToggleTpl';

/**
 * Price Highlight template
 * @param {object} domainHighlight_datas
 * @param {object|boolean} domainHighlight_datas.product_datas
 * @param {object} domainHighlight_datas.product_datas.cache
 * @param {object} domainHighlight_datas.product_datas.housing
 * @param {object} domainHighlight_datas.product_datas.brand
 * @param {object} domainHighlight_datas.product_datas.actionCode
 * @param {object} domainHighlight_datas.participants
 * @param {number} domainHighlight_datas.totalParticipants
 * @return {string} - Formatted HTML
 */
export const priceHighlightTpl = (domainHighlight_datas) => {
  const includedServices = [];
  const hasProductDispo = !domainHighlight_datas.product_datas ? false : true;
  let button = '';
  let htmlDuration = '';
  let priceFormatted = '';
  let htmlPrice = '';
  let datesFromToString = '';
  let item = '';
  let priceFrom = '';
  let itemDispo = '';
  if (hasProductDispo) {
    item = domainHighlight_datas.product_datas;
    datesFromToString = datesFromTo(item.cache.date, item.cache.dateEnd, GLOBAL_SCRIPTS.WORDINGS_COMMON.from_month, GLOBAL_SCRIPTS.WORDINGS_COMMON.to_month);
    itemDispo = item.cache.dispo === 1 ? true : false;
    if (datesFromToString !== '') {
      htmlDuration += `<p class="domainHighlight-duration">${datesFromToString}`;
      if (item.cache.duration > 0) {
        htmlDuration += ` (${item.cache.duration + 1} ${GLOBAL_SCRIPTS.WORDINGS_COMMON.days} - ${item.cache.duration} ${GLOBAL_SCRIPTS.WORDINGS_COMMON.nights})`;
      }
      htmlDuration += '</p>';
    }
    priceFrom = `<span class="priceFrom">${GLOBAL_SCRIPTS.WORDINGS_COMMON.from_price.charAt(0).toUpperCase() + GLOBAL_SCRIPTS.WORDINGS_COMMON.from_price.slice(1)}</span>`;
    const htmlCurrency = `<span class="currency">${GLOBAL_SCRIPTS.CURRENCY_SYMBOL}</span>`;
    priceFormatted = `${!GLOBAL_SCRIPTS.CURRENCY_IS_AFTER ? htmlCurrency : ''}<span class="price">${item.cache.price.original.value}</span>${GLOBAL_SCRIPTS.CURRENCY_IS_AFTER ? htmlCurrency : ''}`;
    htmlPrice = `<span class="realPrice">${priceFormatted}</span>`;
    if (item.cache.price.promo.value > 0 && parseInt(item.cache.price.promo.value) < parseInt(item.cache.price.original.value)) {
      htmlPrice = `<span class="crossedPrice">${priceFormatted}</span><span class="realPrice">${!GLOBAL_SCRIPTS.CURRENCY_IS_AFTER ? htmlCurrency : ''}<span class="price">${item.cache.price.promo.value}</span>${GLOBAL_SCRIPTS.CURRENCY_IS_AFTER ? htmlCurrency : ''}</span>`;
    }

    if (typeof item.housing.servicesIncludedV2 !== 'undefined' && item.housing.servicesIncludedV2.length) {
      $.each(item.housing.servicesIncludedV2, (i, service) => {
        if (service.regroupement === 'PRICEINCLUDE') {
          includedServices.push(service.name.replaceAll('\'', '’').replaceAll('"', '’'));
        }
      });
    }

    button = itemDispo ? `<div class="mainLink">${PRODUCT_SCRIPTS.WORDING_PRODUCT.seeAllCottages}</div>` : `<div class="mainLink">${PRODUCT_SCRIPTS.WORDING_PRODUCT.seeOthersCottages}</div>`;
  } else {
    datesFromToString = datesFromTo(SEARCH_SCRIPTS.DATE_SELECTED, SEARCH_SCRIPTS.DATE_END_SELECTED, GLOBAL_SCRIPTS.WORDINGS_COMMON.from_month, GLOBAL_SCRIPTS.WORDINGS_COMMON.to_month);
    let durationObject = JSON.parse(SEARCH_SCRIPTS.DURATION_CP);
    let durationTrip = '';
    $.each(durationObject, (i, duration) => {
      if (duration.selected) {
        durationTrip = duration.value;
      } else {
        durationTrip = genericDate.diff(new Date(SEARCH_SCRIPTS.DATE_SELECTED), new Date(SEARCH_SCRIPTS.DATE_END_SELECTED));
      }
    });
    if (datesFromToString !== '') {
      htmlDuration += `<p class="domainHighlight-duration">${datesFromToString}`;
      if (durationTrip > 0) {
        htmlDuration += ` (${durationTrip + 1} ${GLOBAL_SCRIPTS.WORDINGS_COMMON.days} - ${durationTrip} ${GLOBAL_SCRIPTS.WORDINGS_COMMON.nights})`;
      }
      htmlDuration += '</p>';
    }
    button = `<div class="mainText">${PRODUCT_SCRIPTS.WORDING_PRODUCT.indispoForParticipants}</div>`;
  }

  const htmlPriceTooltipToggle = priceTooltipToggleTpl({
    blockClass: 'domainHighlight-tooltip',
    trackingPriceTooltipGaAction: 'bloc cross-sell',
    tooltipOptions: {
      includedServices: includedServices,
      typeTooltip: 'domaine',
      totalParticipants: domainHighlight_datas.totalParticipants,
      participants: domainHighlight_datas.participants,
      taxTotal: hasProductDispo ? item.cache.price.taxTotal : '',
      originalPrice: hasProductDispo ? item.cache.price.original.value : '',
      originalPriceRaw: hasProductDispo ? item.cache.price.original.raw : '',
      originalPriceRawBeforeTax: hasProductDispo ? item.cache.price.original.rawBeforeTax : '',
      petsPrice: hasProductDispo ? item.cache.price.pets.rawBeforeTax : '',
      differencePrice: hasProductDispo ? item.cache.price.difference : '',
      differencePriceRaw: hasProductDispo ? item.cache.price.rawDifference : '',
      discountLabel: hasProductDispo && typeof item.actionCode.name !== 'undefined' && item.actionCode.name !== null && item.actionCode.name.length ? item.actionCode.name.replaceAll('\'', '’').replaceAll('"', '’') : (domainHighlight_datas[genericDate.diff(new Date(), new Date(hasProductDispo ? item.cache.date : '')) > 60 ? 'early_booking_label' : 'last_minute_label']),
      housingLabel: hasProductDispo ? item.housing.housingType.name.replaceAll('\'', '’').replaceAll('"', '’') + ' ' + item.housing.comfortLevel.name + (item.housing.isRenovated ? ' ' + GLOBAL_SCRIPTS.WORDINGS_CROSSSELL.label_renovated : '') : '',
      dateLabel: datesFromToString,
      maxPersons: hasProductDispo ? item.cache.maxPersons : '',
      isLikeFancy: true,
      brandCode: hasProductDispo ? item.brand.code : '',
      productCode: hasProductDispo ? item.cache.offerCode : ''
    }
  });

  return `
      <div class="domainHighlight-priceBlock">
        ${htmlDuration}
        ${!itemDispo && hasProductDispo ? `<p class="domainHighlight-message">${PRODUCT_SCRIPTS.WORDING_PRODUCT.noDispoForDates}</p>` : ''}
        ${priceFrom !== '' && itemDispo ? `
          <div class="domainHighlight-priceValue">
            ${priceFrom}
            ${htmlPrice}
            ${htmlPriceTooltipToggle}
          </div>` : ''}

      </div>
      ${button}`;
};